'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ValueVertical',

  props: ['state', 'option', 'value'],

  computed: {
    isSelected: function isSelected() {
      return (0, _keys2.default)(this.state).includes('option_' + this.option.id) && this.state['option_' + this.option.id] === this.value.id;
    }
  },

  methods: {
    onClick: function onClick() {
      this.$emit('clicked', this.value.id);
    }
  }
};